import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TransactionType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

type TCapManageKeyTranslator = (
	key: Parameters<TranslateFunction<I18Namespaces.CAP_MANAGE>>[0]
) => string;

export const getTransactionTypes = (tCapManage: TCapManageKeyTranslator) => {
	const TRANSACTION_TYPE_MAPPING: Record<TransactionType, { text: string }> = {
		[TransactionType.TRANSFER]: {
			text: tCapManage('transactions.types.transfer'),
		},
		[TransactionType.ISSUE]: {
			// `issue`, not `new_issue`: the document-facing label in `liquidJs.ts` is "Issue",
			// and the same transaction type reading two ways on screen and in the deed
			// generated from that screen is what a client notices.
			text: tCapManage('transactions.types.issue'),
		},
		[TransactionType.ISSUE_SPLIT]: {
			text: tCapManage('transactions.types.issue_split'),
		},
		[TransactionType.REDEMPTION]: {
			text: tCapManage('transactions.types.redemption'),
		},
		[TransactionType.REDEMPTION_REVERSE_SPLIT]: {
			text: tCapManage('transactions.types.redemption_reverse_split'),
		},
		[TransactionType.CANCELLATION]: {
			text: tCapManage('transactions.types.cancellation'),
		},
		[TransactionType.DIVIDEND]: {
			text: tCapManage('transactions.types.dividend'),
		},
		[TransactionType.CONVERSION_SHARE_CAPITAL]: {
			// The old key said "transfer"; this type is a CONVERSION, and the document says so.
			text: tCapManage('transactions.types.conversion_of_share_capital'),
		},
		[TransactionType.REDUCTION_IN_SHARE_CAPITAL]: {
			text: tCapManage('transactions.types.reduction_in_share_capital'),
		},
		[TransactionType.SHAREHOLDER_CONTRIBUTION]: {
			text: tCapManage('transactions.types.shareholder_contribution'),
		},
		[TransactionType.TRANSFER_CONVERSION]: {
			text: tCapManage('transactions.types.transfer_conversion'),
		},
		// See INTERNAL_ONLY_TRANSACTION_TYPES in transactions.zod.ts.
		[TransactionType.VESTING_EVENT]: {
			text: '',
		},
	};

	return { TRANSACTION_TYPE_MAPPING };
};

export const getTransactionTypeText = (
	type: TransactionType | undefined,
	tCapManage: TCapManageKeyTranslator
): string => {
	if (!type) {
		return '';
	}
	const { TRANSACTION_TYPE_MAPPING } = getTransactionTypes(tCapManage);
	return TRANSACTION_TYPE_MAPPING[type].text;
};
